import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormNumber,[aFormNumber]',
    templateUrl: './aFormNumber.component.html',
    styleUrls: ['./aFormNumber.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormNumberComponent, multi: true }
    ]
})
export class AFormNumberComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    formControl;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService:RootService) {

    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormNumber/aFormNumber.component.ts